import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { startHydration, hydrationDone } from './prerender-data';
import { STANDALONE_PAGES, loadStandalonePage } from './standalone-pages';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pages saved at publish time (scripts/prerender.js) are marked with the address they were saved for.
// If this is that page, take over the saved HTML instead of redrawing it. Otherwise start fresh.
const savedFor = container.getAttribute('data-prerendered');
const here = window.location.pathname.replace(/\/+$/, '') || '/';

const takeOver = savedFor && savedFor === here && container.firstChild;

function start() {
  if (takeOver) {
    startHydration();
    ReactDOM.hydrateRoot(container, app, {
      onRecoverableError: (error) => {
        console.error('[prerender] The saved page did not match and was redrawn:', error);
        hydrationDone();
      },
    });
  } else {
    hydrationDone();
    ReactDOM.createRoot(container).render(app);
  }
}

// A standalone procedure page keeps its code in its own file (src/standalone-pages.js). The saved page
// can only be taken over once that code is here, so fetch it first. The saved page stays on screen
// meanwhile, and the download was already started from the page's <head>.
if (takeOver && STANDALONE_PAGES[here]) {
  loadStandalonePage(here).then(start, start);
} else {
  start();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
